import * as React from 'react';
import { detect, BrowserInfo, Browser } from 'detect-browser';
import {
  browserConfig,
  BrowserConfigType
} from 'components/onboarding/extensionConfig';
import ExtensionInstallButton from 'components/onboarding/install_button';
import { getLangKey } from 'models/Language';
import * as translations from './strings';
import styles from './index.module.css';
import { JavascriptContent } from 'appJS/views/new_project_settings/InstallBugherd/JavascriptContent';

interface Props {
  project: {
    apiKey: string;
    id: string;
    javascriptInstalledOverride: boolean;
  };
  bugherdUrl: string;
  onInstallCallback: (isWordpress?: boolean) => void;
  goToNextStep: () => void;
  isOnboarding?: boolean;
  showEmbedJavascript: boolean;
  setShowEmbedJavascript: (show: boolean) => void;
  containerClassName?: string;
}

const InstallBugherd: React.FC<Props> = ({
  project,
  bugherdUrl,
  onInstallCallback,
  goToNextStep,
  isOnboarding,
  showEmbedJavascript,
  setShowEmbedJavascript,
  containerClassName
}) => {
  const strings = translations[getLangKey()];

  const browser: BrowserInfo = detect() as BrowserInfo;
  const currentBrowser: Browser = browser.name;

  const getBrowserConfig: () => BrowserConfigType | null = () =>
    currentBrowser === null
      ? null
      : (browserConfig.find(
          browserInfo => browserInfo.name === currentBrowser
        ) as BrowserConfigType);

  const hasBrowserExtension = !!getBrowserConfig();

  React.useEffect(() => {
    setShowEmbedJavascript(!hasBrowserExtension);
  }, []);

  const extensionSupported: () => React.ReactNode = () => (
    <div>
      <div className={styles.installBhBtn}>
        <ExtensionInstallButton
          browserConfig={getBrowserConfig()}
          isSignUpOnBoarding
        />
      </div>
      <p className={styles.installJsText}>
        {strings.or}{' '}
        <a onClick={() => setShowEmbedJavascript(true)}>
          {strings.installJsText}
        </a>
      </p>
    </div>
  );

  const showBrowserExtension: boolean =
    !showEmbedJavascript && hasBrowserExtension;

  return (
    <div className={`${styles.stepContainer}${containerClassName ? ` ${containerClassName}` : ''}`}>
      {showBrowserExtension ? (
        extensionSupported()
      ) : (
        <div className={styles.javascriptContentWrapper}>
          <JavascriptContent
            onInstallCallback={onInstallCallback}
            project={project}
            bugherdUrl={bugherdUrl}
            isOnboarding={!!isOnboarding}
            goToNextStep={goToNextStep}
          />
          {hasBrowserExtension && (
            <div className={styles.showExtensionOuter}>
              <span>or</span>
              <a onClick={() => setShowEmbedJavascript(false)}>
                {strings.installExtMessage}
              </a>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default InstallBugherd;